<template>
  <div>
    <v-row>
      <v-col cols="4" class="mb-4">
        <h2 class="title" v-text="$t('exercise_activation.step1.title')"></h2>
      </v-col>
      <v-col cols="6" class="">
        <p
          v-for="(item, index) in $t('exercise_activation.step1.description')"
          :key="index"
          v-text="item"
        />
        <ol>
          <li
            v-for="(item, index) in $t('exercise_activation.step1.list')"
            :key="index"
            v-text="item"
          />
        </ol>
        <v-btn light class="amber pa-5 mt-10" @click="addIdea" large
          >Add an new idea</v-btn
        >
      </v-col>
    </v-row>
    <v-row>
      <!-- Exercise column -->
      <v-col cols="12">
        <exercise-logic-multiple
          exCollection="activateStarExCollection"
          refCollection="activateExCollection"
          @ready="onReady"
          @error="onError"
          @saved="onSaved"
          @savedNext="onSavedNext"
          @loadedRef="onLoadedRef"
          @modifyRef="onModifyRef"
          @loadedEx="onLoadedEx"
          @addRef="onAddRef"
          :doc="doc"
          :pid="true"
          :shared="false"
          class="row"
        >
          <template slot-scope="{ saveExercise }">
            <v-col cols="12" v-if="refs">
              <div id="iso" class="row">
                <v-col
                  v-for="(item, index) in refs"
                  :key="`ex-${index}`"
                  cols="4"
                  class="iso-item"
                >
                  <activation-card
                    :item="item"
                    @showNote="showNote"
                    @editNote="editNote"
                    @deleteNote="deleteNote"
                    @selectNote="selectNote"
                    :selectedItems="doc.selectedItems"
                  ></activation-card>
                </v-col>
              </div>
            </v-col>

            <bottom-navigation
              :save="true"
              :next="false"
              :prev="false"
              :gridView="false"
              :gridToggle="false"
              @save="saveExercise(true)"
              @prev="prevStep"
              @next="nextStep"
            >
            </bottom-navigation>
          </template>
        </exercise-logic-multiple>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="980">
      <v-card v-if="dialogMode == 'save'">
        <v-card-title
          class="headline"
          v-text="$t('exercise_activation.saved.title')"
        ></v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="closeDialog">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-card v-if="dialogMode == 'add'">
        <v-card-text>
          <activation-add @complete="closeDialog" />
        </v-card-text>
      </v-card>

      <v-card v-if="dialogMode == 'show'">
        <v-card-text class="pa-10">
          <activation-show :id="cardId" @complete="closeDialog" />
        </v-card-text>
      </v-card>

      <v-card v-if="dialogMode == 'edit'">
        <v-card-title class="headline">Edit idea</v-card-title>

        <v-card-text>
          <activation-edit :id="cardId" @complete="closeDialog" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import { BottomNavigation } from "@/components/core";
import { ExerciseLogicMultiple } from "@/components/exercises";
import { UnitTextArea, UnitTextField, UnitTag } from "@/components/units";
import {
  ActivationAdd,
  ActivationCard,
  ActivationEdit,
  ActivationShow,
} from "@/views/user/exercises/activation";

const fb = require("@/firebaseConfig.js");
import { Isotope } from "@/vendor";

export default {
  name: "UserActivation",
  data() {
    return {
      e1: 1,
      iso: null,
      exercises: null,
      refs: null,
      exercise: null,
      dialog: false,
      dialogMode: "add",
      cardId: null,
      doc: {
        selectedItems: [],
      },
      tabs: [
        {
          title: "Concept",
          count: 1,
          component: UnitTextArea,
          model: "concept",
          color: "red",
          next: true,
          prev: false,
          save: false,
          prefix: "",
        },
        {
          title: "Sentence",
          count: 2,
          component: UnitTextArea,
          model: "sentence",
          next: true,
          prev: false,
          save: false,
          prefix: "",
        },
        {
          title: "Hashtag",
          count: 3,
          component: UnitTextField,
          model: "hashtag",
          next: true,
          prev: false,
          save: false,
          prefix: "#",
        },
        {
          title: "Activations",
          count: 4,
          component: UnitTag,
          model: "channels",
          next: true,
          prev: false,
          save: false,
          prefix: "",
        },
        {
          title: "Engagement",
          count: 5,
          component: UnitTag,
          model: "earned",
          next: false,
          prev: false,
          save: true,
          prefix: "",
        },
      ],
      debug: false,
    };
  },
  components: {
    BottomNavigation,
    ExerciseLogicMultiple,
    // UnitTextArea,
    // UnitTextField,
    // UnitTag,
    ActivationAdd,
    ActivationCard,
    ActivationEdit,
    ActivationShow,
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
    selectedItems() {
      return this.refs
        ? this.refs.filter((item) => item.selected === true)
        : [];
    },
  },

  mounted() {},
  methods: {
    nextStep() {
      this.e1++;
    },
    prevStep() {
      this.e1--;
    },
    onReady() {},
    onError() {
      console.log("error");
    },
    onSaved() {
      console.log("saved");
    },
    onLoadedRef(items) {
      console.log("loaded exercises", items);
      this.refs = items;
    },
    onLoadedEx(exercise) {
      if (exercise) {
        console.log("loaded exercise", exercise);
        this.doc = exercise.doc;
      }
      this.initIso();
    },
    onModifyRef(items) {
      console.log("modify exercises", items);
      this.refs = [...items];
      this.layout();
    },
    onAddRef(items) {
      console.log("added exercises", items);
      this.refs = [...this.refs, ...items];
      this.layout();
    },
    onSavedNext() {
      this.nextStep();
    },
    addIdea() {
      this.dialogMode = "add";
      this.dialog = true;
    },
    editNote($event) {
      console.log("edit note", $event);
      this.dialogMode = "edit";
      this.cardId = $event;
      this.dialog = true;
    },
    showNote($event) {
      console.log("show note", $event);
      this.dialogMode = "show";
      this.cardId = $event;
      this.dialog = true;
    },
    selectNote(id, active) {
      console.log(id, active);
      if (active == true) {
        if (!this.doc.selectedItems.some((item) => item === id)) {
          this.doc.selectedItems.push(id);
        }
      } else {
        let indexOfItem = this.doc.selectedItems.indexOf(id);
        this.doc.selectedItems.splice(indexOfItem, 1);
      }
    },
    closeDialog() {
      this.dialog = false;
      this.dialogMode = "";
    },
    deleteNote($event) {
      fb.activateExCollection
        .doc($event)
        .delete()
        .then(() => {
          this.dialog = false;
          this.cardId = null;
          this.dialogMode = null;
        })
        .catch((error) => {
          alert("Error removing document: ", error);
        });
    },
    initIso() {
      this.iso = null;
      let isoEl = document.getElementById("iso");
      this.iso = new Isotope(isoEl, {
        itemSelector: ".iso-item",
        layoutMode: "packery",
        transitionDuration: 0,
        hiddenStyle: {
          opacity: 0,
        },
        visibleStyle: {
          opacity: 1,
        },
      });
    },
    layout() {
      if (this.iso) {
        this.iso.layout();
      }
    },
  },
};
</script>

<style lang="scss"></style>
